import FormatAlignCenterIcon from "@mui/icons-material/FormatAlignCenter";
import FormatAlignJustifyIcon from "@mui/icons-material/FormatAlignJustify";
import FormatAlignLeftIcon from "@mui/icons-material/FormatAlignLeft";
import FormatAlignRightIcon from "@mui/icons-material/FormatAlignRight";
import { Tooltip } from "@mui/material";

import MenuButton from "../MenuButton";

const AlignmentButtons = ({ editor }) => {
	if (!editor) return null;

	return (
		<>
			<Tooltip title="Align Left">
				<MenuButton
					isActive={editor.isActive({ textAlign: "left" })}
					onClick={() => editor.chain().focus().setTextAlign("left").run()}
				>
					<FormatAlignLeftIcon fontSize="small" />
				</MenuButton>
			</Tooltip>
			
			<Tooltip title="Align Center">
				<MenuButton
					isActive={editor.isActive({ textAlign: "center" })}
					onClick={() => editor.chain().focus().setTextAlign("center").run()}
				>
					<FormatAlignCenterIcon fontSize="small" />
				</MenuButton>
			</Tooltip>
			
			<Tooltip title="Align Right">
				<MenuButton
					isActive={editor.isActive({ textAlign: "right" })}
					onClick={() => editor.chain().focus().setTextAlign("right").run()}
				>
					<FormatAlignRightIcon fontSize="small" />
				</MenuButton>
			</Tooltip>
			
			<Tooltip title="Justify">
				<MenuButton
					isActive={editor.isActive({ textAlign: "justify" })}
					onClick={() => editor.chain().focus().setTextAlign("justify").run()}
				>
					<FormatAlignJustifyIcon fontSize="small" />
				</MenuButton>
			</Tooltip>
		</>
	);
};

export default AlignmentButtons;